<tabset #artabset type="tabs"  class="tabs-animated tabs-animated-shadow tabs-bordered" [justified]="true">
    <tab id="arUnassignedTab" >
        <ng-template tabHeading>
            <span> Payment Type Pending Transactions </span>
        </ng-template>
        <app-ar-unassigned></app-ar-unassigned>
    </tab>
    <tab id="arAssignedTab">
        <ng-template tabHeading>
            <span> To Be Billed Transactions</span>
        </ng-template>
        <app-ar-assigned></app-ar-assigned>
    </tab>
    <tab id="arPaid">
        <ng-template tabHeading>
            <span>Paid Transactions</span>
        </ng-template>
        <app-ar-paid> </app-ar-paid>
    </tab>
</tabset>
